import { MemoizedSelector, Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';

import type { FullCandidate } from '@recruitee/candidate-types';
import { filterBoolean } from '@recruitee/common';
import { CandidateVisitedSnapshot, ResourceKind } from '@recruitee/recent-navigation';

const mapToRecentNavigationSnapshot = (candidate: FullCandidate): CandidateVisitedSnapshot => {
  const { id, name, hasAvatar, initials, photoThumbUrl, isAnonymous } = candidate;
  return {
    id,
    name,
    hasAvatar,
    initials,
    photoThumbUrl,
    kind: ResourceKind.Candidate,
    isAnonymous,
  };
};

export const candidateResolver = (
  store: Store,
  selector: MemoizedSelector<object, FullCandidate | null>,
): Observable<CandidateVisitedSnapshot> =>
  store.select(selector).pipe(filterBoolean, take(1), map(mapToRecentNavigationSnapshot));
